export const PLUGIN_CONFIG_EVENTS = {
  TRANSMIT_CONFIG: 'transmit_config',
};

export const WMS_CHART_SERVER_EVENTS = {
  OAUTH_REQUEST: 'get_token_request',
  TOKEN_INVALID: 'wms_token_invalid'
};
